import { useEffect } from "react";

const DEFAULT_TITLE = "Family Repository — Preserve Your Family Legacy Forever";

export function useDocumentMeta(title, description) {
    useEffect(() => {
        const prevTitle = document.title;
        if (title) document.title = title;
        let meta = document.querySelector('meta[name="description"]');
        const prevDesc = meta?.getAttribute("content");
        if (description && meta) meta.setAttribute("content", description);
        return () => {
            document.title = prevTitle || DEFAULT_TITLE;
            if (meta && prevDesc) meta.setAttribute("content", prevDesc);
        };
    }, [title, description]);
}
